// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-unit-list {
  height: calc(100% - 42px);
}

.UnitsList {
  margin-left: 15px;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./Source/app/billing/billing-unit/billing-unit-list/billing-unit-list.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;AACJ","sourcesContent":[".billing-unit-list {\r\n    height: calc(100% - 42px);\r\n}\r\n\r\n.UnitsList {\r\n    margin-left: 15px;\r\n    margin-top: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
